import React from "react";

const Button = ({ text, disabled, onClick, type = "button", className = "btn-primary" }) => {
    return (
        <button type={type} className={`btn ${className} mx-2`} onClick={onClick} disabled={disabled}>
            {text}
        </button>
    );
};

export default Button;
